import type { EdgeClient } from 'common/generated/edgeClient'

export class StatusApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async listStatus(): ReturnType<EdgeClient['listStatuses']> {
    return this.edgeClient.listStatuses()
  }
}
